import React from 'react';
import classNames from 'classnames'



const Tag = ({ tag, index,  handleDeleteTag, addTagToLine, addTagToFilter, indexLine, active, type, keyLine}) => {
    const tagClass = classNames({
        'tag': true,
        'active': active
    });

    let renderTag = '';


    switch (type){
        case 'addToLine':
            renderTag = (
                <div data-type={type}  className={tagClass} style={{color:tag.color}} onClick={() => addTagToLine(index, keyLine)}>
                    <div className="tag__hint">{tag.text} </div>
                    {
                        handleDeleteTag && (
                            <div className="tag__remove" onClick={() => handleDeleteTag(index)}>
                                <i className="icon-close"></i>
                            </div>
                        )
                    }
                </div>
            )
            break
        case 'filter':
            const style = {
                color:tag.color,
                borderColor: active && tag.color,
                background: 'none'
            }
            renderTag = (
                <div data-type={type} className={tagClass} style={style} onClick={(e) => {
                    e.stopPropagation();
                    e.nativeEvent.stopImmediatePropagation();
                    addTagToFilter(tag.id)}
                }>
                    <div className="tag__hint">{tag.text} </div>
                    {
                        handleDeleteTag && (
                            <div className="tag__remove" onClick={() => handleDeleteTag(index)}>
                                <i className="icon-close"></i>
                            </div>
                        )
                    }
                </div>
            )
            break

        default:
            !tag ? renderTag :
            renderTag = (
                <div data-type={type} className={tagClass} style={{color:tag.color}} onClick={() => {}}>
                    <div className="tag__hint">{tag.text} </div>
                    {
                        handleDeleteTag && (
                            <div className="tag__remove" onClick={() => handleDeleteTag(index)}>
                                <i className="icon-close"></i>
                            </div>
                        )
                    }
                </div>
            )

    }
    return renderTag
}




export default Tag;


// WEBPACK FOOTER //
// ./src/components/Tag.js